import { Box, Card, Container, Grid, makeStyles, Typography } from '@material-ui/core';
import classNames from 'classnames';
import { Loader, SGSButton } from 'components';
import { CalendarProvider } from 'components/SGSCalendar/CalendarContext ';
import SGSMuiStepper from 'components/SGSMuiStepper';
import { useCustomStyles } from 'core/mui/customStyles';
import { affilieService } from 'core/services';
import { useQueryConf } from 'core/utils/useQuery';
import IndemniteCalendar from 'features/dossierIncapacite/components/IndeminiteCalendar';
import moment from 'moment';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useQuery } from 'react-query';
import { useHistory } from 'react-router';
import { useParams } from 'react-router-dom';
import retour from '../../../assets/retour.svg';
import verticalDivider from '../../../features/dossierIncapacite/assets/verticalDivider.svg';
import styles from './Dossier.module.scss';
import ListIndemnite from './ListIndemnite';

import { CloudDownloadIcon, CloudUploadIcon } from '@heroicons/react/solid';
import SGSModalBlue from 'components/Modal';
import { exportExcelPrestations } from 'core/services/affilie';
import { uniqueId } from 'lodash';
import encours from '../../../features/dossierIncapacite/assets/encours2.svg';
import warning from '../../../features/dossierIncapacite/assets/warning.svg';
import DocumentsTable from './DocumentsTable';
import FormSendDocument from './FormSendDocument';
//import { toast } from 'react-toastify';
//import CloudDownloadIcon from '@mui/icons-material/CloudDownload';
//var FileSaver = require('file-saver');

type Dossier = {
    id: string;
    codAssure: string;
    lbSouscrip: string;
    dtDeclaration: string;
    lbNatureSinistre: string;
    dtSinitre: string;
    dtCreation: string;
    dtCloture: string;
    lbMotifCloture: string;
    causeSinitre: string;
    affiliate: {
        nom: string;
        prenom: string;
        numSecu: string;
        adresse: string;
        codePostal: string;
        ville: string;
    };
    status: string;
    blAlert: string;
    contrat: {
        lbContrat: string;
        lbCollege: string;
    };
};

type Event = {
    title: string;
    start: Date;
    end: Date;
};

interface MyData {
    reference: string;
    // Other properties...
}

const useStyles = makeStyles(() => ({
    verticalDivider: {
        background: `url(${verticalDivider}) center/contain repeat-Y`,
    },
    column: {
        height: '100%',
    },
}));

type Props = {};
const DetailDossierPrev: React.FC<Props> = () => {
    const { t } = useTranslation();
    const [dossier, setDossier] = useState<Dossier>();
    const [events, setEvents] = useState<Event[]>();

    const [indemnites, setIndemnites] = useState([]);
    const [lastIndemniteDate, setLastIndemniteDate] = useState([]);
    const commonStyles = useCustomStyles();
    const [activeStep, setActiveStep] = useState(1);
    const history = useHistory();
    const { reference }: MyData = useParams();
    const classes = useStyles();
    //const [isLoadingPdf, setIsLoadingPdf] = useState(false);
    const [isLoadingExcel, setIsLoadingExcel] = useState(false);
    const [isModalOpen, setIsModalOpen] = useState(false);

    const steps = [t('compensation.steps.onGoing'), t('compensation.steps.compensation'), t('compensation.steps.closure')];

    // TODO :: Check 10794050 ??
    const codAffilie = '10794050';
    const compensationId = reference;

    const { isLoading, data: compensation } = useQuery([compensationId, 'compensations'], async () => await affilieService.getCompensationsById(codAffilie, compensationId), useQueryConf);

    useEffect(() => {
        setDossier(compensation);
        const step = parseInt(compensation?.status) ?? 1;
        setActiveStep(step);

        // Create a map to group indemnities by dateVirement.
        let indemnites = compensation?.indemnites ?? [];
        const groupedIndemnities = new Map();
        indemnites.forEach((indemnity) => {
            const dateVirement = indemnity.dateVirement;

            if (!groupedIndemnities.has(dateVirement)) {
                groupedIndemnities.set(dateVirement, {
                    dateVirement,
                    montantTotal: 0,
                    details: [],
                });
            }

            const group = groupedIndemnities.get(dateVirement);
            group.montantTotal = indemnity.montantTotal;
            group.details.push({
                nbreJourArret: indemnity.nbreJourArret,
                dtDebPresta: indemnity.dtDebPresta,
                dtFinPresta: indemnity.dtFinPresta,
                lbActe: indemnity.montantNet < 0 ? 'Trop-perçu' : indemnity.lbActe,
                lbModPaiment: indemnity.montantNet < 0 ? '-' : indemnity.lbModPaiment,
                montantNet: indemnity.montantNet,
                montantTotal: indemnity.montantTotal,
                destinataire: indemnity.montantNet < 0 ? '-' : indemnity.destinataire,
                isPaidToAffilie: indemnity.isPaidToAffilie === '1',
                iban: indemnity.iban,
                domicileIban: indemnity.domicileIban,
                bic: indemnity.bic,
                revenuref: indemnity.revenuref,
                unitss: indemnity.unitss,
            });
        });

        // order by date paiment
        const sortedEntries = Array.from(groupedIndemnities.entries()).sort(([keyA], [keyB]) => keyA.localeCompare(keyB));
        const sortedMap = new Map(sortedEntries);

        const reorganizedData = Array.from(groupedIndemnities.values());
        setIndemnites(reorganizedData);

        // Function to merge details into one event
        const mergeDetails = (details, key) => {
            let mergedEvent = {
                //details: [],
                id: null,
                start: null,
                end: null,
                montantNet: null,
                dateVirement: null,
                allDay: true,
                title: null,
            };

            // Find earliest start date and latest end date
            let earliestStartDate = details[0].dtDebPresta;
            let latestEndDate = details[0].dtFinPresta;
            details.forEach((detail) => {
                if (detail.dtDebPresta < earliestStartDate) {
                    earliestStartDate = detail.dtDebPresta;
                }
                if (detail.dtFinPresta > latestEndDate) {
                    latestEndDate = detail.dtFinPresta;
                }
            });

            mergedEvent.id = uniqueId();
            mergedEvent.start = earliestStartDate;
            mergedEvent.end = latestEndDate;
            mergedEvent.montantNet = details[0].montantTotal;
            mergedEvent.dateVirement = key;
            mergedEvent.title = details[0].montantTotal < 0 ? 'Trop-perçu' : details[0].lbActe;

            return mergedEvent;
        };

        // Create a new map to store merged events
        const mergedEvents = new Map();

        // Iterate over the main map and merge details for each event excluding trop-perçu (Calendar)
        sortedMap.forEach((value, key) => {
            if (value.montantTotal >= 0) mergedEvents.set(key, mergeDetails(value.details, key));
        });

        const reorganizedEvents = Array.from(mergedEvents.values());

        setEvents(reorganizedEvents);

        // Get last payment data
        // Extract the "dateVirement" values into an array
        const dtFinPrestas = indemnites.map((item) => item.dtFinPresta);

        // Find the maximum date in the array
        const maxDate = dtFinPrestas.reduce((maxDate, currentDate) => {
            return currentDate > maxDate ? currentDate : maxDate;
        }, dtFinPrestas[0]);

        setLastIndemniteDate(maxDate);

        window.scrollTo(0, 0);
    }, [compensation]);

    const goToDossier = () => {
        history.push(`/affiliations/${dossier.codAssure}/indemnisation`);
    };

    const documents = [
        {
            nom: '...',
            dtReception: '',
            statut: 'En attente',
            commentaire: 'Preuve à fournir ',
        },
    ];

    const documents2 = [
        {
            nom: 'Attestation du médecin',
            dtReception: '',
            statut: 'En attente',
            commentaire: "Document à transmettre pour renouveller l'indemnisation",
        },
    ];

    const stepFailed = dossier?.blAlert === '1' ? parseInt(dossier.status) : null;

    const WarningDocument = ({ documents }) => {
        return (
            <>
                <Box display="flex" className="mt-5">
                    <Box display={'flex'} justifyContent={'center'} alignItems={'stretch'} className="mr-5" flexDirection={'row'}>
                        <Box flex={1} display="flex" justifyContent="flex-end">
                            <img src={warning} />
                        </Box>
                        <Box flex={1} display="flex" flexDirection="column" alignItems="center" className={classNames(styles.txtBlueDark, 'ml-2')}>
                            <Box flex={1} display="flex" flexDirection="column">
                                <Box className="text-nowrap">
                                    <strong>Le dossier est incomplet ! </strong>
                                </Box>
                                <Box className="text-nowrap">
                                    <strong></strong>
                                </Box>
                            </Box>
                        </Box>
                    </Box>
                </Box>
                <Box className="mt-3">
                    <DocumentsTable documents={documents} />
                </Box>
            </>
        );
    };

    // const handleDownloadPeriod = async () => {
    //     setIsLoadingPdf(true);

    //     //  moment(compensation.dtSinitre, 'YYYY-MM-DD').format('DD/MM/YYYY')} au {moment(lastIndemniteDate, 'YYYY-MM-DD').format('DD/MM/YYYY')
    //     const startPeriodFR = moment(compensation.dtSinitre, 'YYYY-MM-DD').format('DDMMYYYY');
    //     const endPeriodFR = moment(lastIndemniteDate, 'YYYY-MM-DD').format('DDMMYYYY');

    //     try {
    //         await affilieService
    //             .exportPdfCompensationByPeriod({ codAffilie, compensationId })
    //             .then((res) => {
    //                 const fileName = 'Decompte_prevoyance_' + compensationId + '_' + startPeriodFR + '_' + endPeriodFR + '.pdf';
    //                 var blob = new Blob([res], { type: 'application/pdf' });
    //                 FileSaver.saveAs(blob, fileName);
    //             })
    //             .catch((error) => {
    //                 console.error('Error fetching PDF:', error);
    //             })
    //             .finally(() => {
    //                 //
    //             });
    //     } catch (e) {
    //         // Error message
    //         toast.error('Une erreur est survenue durant le création du fichier Excel');
    //     }
    //     setIsLoadingPdf(false);
    // };

    const handleExportExcel = async (compensationId) => {
        setIsLoadingExcel(true);
        exportExcelPrestations(compensationId)
            .then((data) => {
                const url = window.URL.createObjectURL(
                    new Blob([data as BlobPart], {
                        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                    }),
                );
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', `prestations.xlsx`);
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            })
            .finally(() => {
                setIsLoadingExcel(false);
            });
    };

    const handleModalOpen = () => setIsModalOpen(true);

    return (
        <>
            <Container maxWidth={'xl'} style={{ height: '100%' }}>
                <Card style={{ height: '100%', paddingLeft: '50px', paddingRight: '50px' }}>
                    <Box sx={{ width: '100%', height: '100%' }}>
                        {!isLoading && dossier ? (
                            <>
                                <Box className="p-5">
                                    <Grid container spacing={2}>
                                        <Grid item xs={12} md={8} className={styles.titre}>
                                            <Box display={'flex'} alignItems={'center'} justifyContent={'flex-start'} onClick={handleModalOpen} style={{ cursor: 'pointer' }}>
                                                <SGSButton>
                                                    <CloudUploadIcon width={'20px'} height={'20px'} />
                                                    <Box component={'span'} className="ml-2">
                                                        ENVOYER UN DOCUMENT
                                                    </Box>
                                                </SGSButton>
                                            </Box>
                                        </Grid>
                                        <Grid item xs={12} md={4}>
                                            <Box display={'flex'} alignItems={'center'} justifyContent={'flex-end'} onClick={goToDossier} style={{ cursor: 'pointer' }}>
                                                <img src={retour} className="mr-2" /> <span className={styles.btnRetour}>Retour aux dossiers</span>
                                            </Box>
                                        </Grid>
                                        <Grid item xs={12} md={1}></Grid>
                                        <Grid item xs={12} md={10}>
                                            <SGSMuiStepper steps={steps} activeStep={activeStep} setActiveStep={setActiveStep} stepFailed={stepFailed} />
                                        </Grid>
                                        <Grid item xs={12} md={1}></Grid>
                                    </Grid>
                                    <Grid container spacing={0} className="mt-5">
                                        <Grid item xs={12} sm={3}>
                                            <Box className={classes.column}>
                                                <Box className={styles.titre}>{t('compensation.dossier.referenceDossier')} :</Box>
                                                <Box className={classNames(styles.interTitre, 'mt-3 mb-1')}>{dossier.id}</Box>
                                                <Box className={styles.txtBlueDark} display={'flex'}>
                                                    <Box className="text-nowrap mr-1">{t('compensation.dossier.agency')} :</Box>
                                                    <Box className="text-nowrap">
                                                        <strong>{dossier.lbSouscrip}</strong>
                                                    </Box>
                                                </Box>
                                                <Box className={styles.txtBlueDark} display={'flex'}>
                                                    <Box className="text-nowrap mr-1">Contrat :</Box>
                                                    <Box className="text-nowrap">
                                                        <strong>{dossier?.contrat?.lbContrat}</strong>
                                                    </Box>
                                                </Box>
                                                <Box className={styles.txtBlueDark} display={'flex'}>
                                                    <Box className="text-nowrap mr-1">Categorie :</Box>
                                                    <Box className="text-nowrap">
                                                        <strong>{dossier?.contrat?.lbCollege}</strong>
                                                    </Box>
                                                </Box>
                                            </Box>
                                        </Grid>
                                        <Grid item xs={12} sm={1}>
                                            <Box className={classNames(classes.column, classes.verticalDivider)}></Box>
                                        </Grid>
                                        <Grid item xs={12} sm={3}>
                                            <Box className={classes.column}>
                                                <Box flex={1}>
                                                    <Box className={styles.titre}>Assuré :</Box>
                                                    <Box className={classNames(styles.interTitre, 'mt-3  mb-1')}>
                                                        {dossier.affiliate.prenom} {dossier.affiliate.nom}
                                                    </Box>
                                                    <Box className={styles.txtBlueDark}>
                                                        {t('compensation.dossier.nir')} : <strong>{dossier.affiliate.numSecu}</strong>
                                                    </Box>
                                                    <Box className={classNames(styles.txtBlueDark, 'mt-2')} display={'flex'}>
                                                        <Box className="mr-1 text-nowrap">{t('compensation.dossier.address')} :</Box>
                                                        <Box>
                                                            <Box>
                                                                <strong>{dossier.affiliate.adresse}</strong>
                                                            </Box>
                                                            <Box>
                                                                <strong>
                                                                    {dossier.affiliate.codePostal} {dossier.affiliate.ville}
                                                                </strong>
                                                            </Box>
                                                        </Box>
                                                    </Box>
                                                </Box>
                                            </Box>
                                        </Grid>
                                        <Grid item xs={12} sm={1}>
                                            <div className={classNames(classes.column, classes.verticalDivider)}></div>
                                        </Grid>
                                        <Grid item xs={12} sm={4}>
                                            <div className={classes.column}>
                                                <Box className={styles.titre}>{t('compensation.status.label')} :</Box>
                                                <Box className="mt-3 mr-4">
                                                    <Box display={'flex'} className={classNames(styles.txtBlue16, '')}>
                                                        <Box className={styles.txtBlueDark}>Déclaration : </Box>
                                                        <Box className="ml-1">{moment(dossier.dtDeclaration, 'YYYY-MM-DD').format('DD/MM/YYYY')}</Box>
                                                    </Box>

                                                    <Box display={'flex'} className={classNames(styles.txtBlue16, 'mr-4')}>
                                                        <Box className={styles.txtBlueDark}>Nature : </Box>
                                                        <Box className="ml-1">
                                                            {dossier.lbNatureSinistre} du {moment(dossier.dtSinitre, 'YYYY-MM-DD').format('DD/MM/YYYY')}
                                                        </Box>
                                                    </Box>
                                                </Box>

                                                {dossier.status === '2' && (
                                                    <>
                                                        <Box display={'flex'} className={classNames(styles.txtBlue16, 'mt-2 mr-4')}>
                                                            <Box className={styles.txtBlueDark}>Clôture : </Box>
                                                            <Box className="ml-1">{moment(dossier.dtCloture, 'YYYY-MM-DD').format('DD/MM/YYYY')}</Box>
                                                        </Box>
                                                        <Box display={'flex'} className={classNames(styles.txtBlue16, 'mr-4')}>
                                                            <Box className={styles.txtBlueDark}>Motif clôture : </Box>
                                                            <Box className="ml-1">{dossier.lbMotifCloture}</Box>
                                                        </Box>
                                                    </>
                                                )}
                                            </div>
                                        </Grid>
                                    </Grid>

                                    {activeStep === 0 && (
                                        <>
                                            {/* Dossier en attente de traitement */}
                                            {dossier.status === '0' && dossier.blAlert === '1' && <WarningDocument documents={documents} />}

                                            {dossier.status === '3' && (
                                                <Box display="flex" justifyContent="center" className="mt-5">
                                                    <Box display={'flex'} justifyContent={'center'} alignItems={'stretch'} className="mr-5" flexDirection={'row'}>
                                                        <Box flex={1} display="flex" justifyContent="flex-end">
                                                            <img src={encours} style={{ height: '100%' }} />
                                                        </Box>
                                                        <Box flex={1} display="flex" flexDirection="column" alignItems="center" className={classNames(styles.txtBlueDark, 'ml-2')}>
                                                            <Box flex={1} display="flex" flexDirection="column">
                                                                <Box className="text-nowrap">
                                                                    <strong>Votre dossier est actuellement incomplet</strong>
                                                                </Box>
                                                                <Box className="text-nowrap">
                                                                    <strong>Veuillez transmettre les documents manquants</strong>
                                                                </Box>
                                                            </Box>
                                                        </Box>
                                                    </Box>
                                                </Box>
                                            )}
                                        </>
                                    )}

                                    {activeStep != 0 && (
                                        <>
                                            {/* Dossier en cours d'indemnisation avec document manquant */}
                                            {dossier.status === '1' && dossier.blAlert === '1' && <WarningDocument documents={documents2} />}

                                            {events.length > 0 && (
                                                <>
                                                    <Box className={styles.calendar}>
                                                        <Box className={styles.titre}>{t('compensation.calendar.label')}</Box>
                                                        <Box className={classNames(styles.txtBlueDark, 'mt-2')}>
                                                            {t('compensation.lexique.label')} : <strong>{t('compensation.lexique.definition')}</strong>
                                                        </Box>
                                                    </Box>

                                                    <CalendarProvider>
                                                        <IndemniteCalendar events={events} />
                                                    </CalendarProvider>
                                                </>
                                            )}
                                            {indemnites.length > 0 && (
                                                <>
                                                    <Box style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                                        <Box style={{ marginRight: '10px' }}>
                                                            <Box className={classNames(styles.blackStrongTxt, 'mt-4')} display="flex" alignItems="center">
                                                                <span className={styles.txtBlueDark}>Période globale du sinistre : </span>
                                                                <span className={styles.interTitre}>
                                                                    du {moment(compensation.dtSinitre, 'YYYY-MM-DD').format('DD/MM/YYYY')} au{' '}
                                                                    {moment(lastIndemniteDate, 'YYYY-MM-DD').format('DD/MM/YYYY')}
                                                                </span>
                                                            </Box>
                                                        </Box>
                                                        <Box>
                                                            <Box className="mt-3" display="flex" alignItems="right">
                                                                <SGSButton type="button" onClick={() => handleExportExcel(compensationId)} loading={isLoadingExcel}>
                                                                    <Box display="flex" className="text-left" alignItems="center">
                                                                        <CloudDownloadIcon style={{ marginRight: '8px', width: '30px' }} />
                                                                        <Typography style={{ fontSize: '0.8rem' }}>Exporter au format Excel</Typography>
                                                                    </Box>
                                                                </SGSButton>
                                                            </Box>
                                                        </Box>
                                                    </Box>

                                                    {/* <Box className="mt-3">
                                                        <SGSButton type="button" onClick={handleDownloadPeriod} loading={isLoadingPdf}>
                                                            <Box display="flex" className="text-left" alignItems="center">
                                                                <CloudDownloadIcon style={{ marginRight: '8px', width: '30px' }} />
                                                                <Typography style={{ fontSize: '0.8rem' }}>Télécharger le récapitulatif de mes indemnisations</Typography>
                                                            </Box>
                                                        </SGSButton>
                                                    </Box> */}
                                                </>
                                            )}

                                            <Box className="mt-3">
                                                {indemnites.map((i) => (
                                                    <ListIndemnite indemnite={i} />
                                                ))}
                                            </Box>
                                        </>
                                    )}
                                </Box>
                            </>
                        ) : (
                            <Box className={styles.loading}>
                                <Box className="mr-5">
                                    <Loader loading={true} />
                                </Box>
                                <Box className={classNames('m-5 pr-5', commonStyles.txtBlueDarkBold)}>Veuillez patienter durant le chargement du dossier...</Box>
                            </Box>
                        )}
                    </Box>
                </Card>
            </Container>
            <SGSModalBlue isOpenModal={isModalOpen} setIsOpenModal={setIsModalOpen} title={'ENVOYER UN DOCUMENT'}>
                <FormSendDocument dossier={dossier} setIsModalOpen={setIsModalOpen} />
            </SGSModalBlue>
        </>
    );
};

export default DetailDossierPrev;
